import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Particle from "../Particle";

function Roadmap() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Development <strong className="purple">Roadmap</strong>
        </h1>
        <p style={{ color: "white" }}>
          Our strategic plan for BESC development and growth
        </p>
        
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={12} className="roadmap-card">
            <Card className="blog-card-view">
              <Card.Body>
                <Card.Title className="purple" style={{ fontSize: "2em" }}>
                  Phase 1: Foundation (0 to 6 Months)
                </Card.Title>
                <Card.Text style={{ textAlign: "left", color: "white" }}>
                  <ul>
                    <li>Develop blockchain infrastructure and smart contracts</li>
                    <li>Dividend Dapp</li>
                    <li>Launch the coin</li>
                    <li>Launch CEX to public</li>
                    <li>Secure partnerships with subcontractors and suppliers</li>
                    <li>Marketing campaigns</li>
                    <li>Begin monthly/quarterly profit-sharing distributions</li>
                    <li>Release CEX mobile APP</li>
                    <li>Recruiters to bring new token listings on CEX</li>
                  </ul>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={12} className="roadmap-card">
            <Card className="blog-card-view">
              <Card.Body>
                <Card.Title className="purple" style={{ fontSize: "2em" }}>
                  Phase 2: Integration (6 to 12 Months)
                </Card.Title>
                <Card.Text style={{ textAlign: "left", color: "white" }}>
                  <ul>
                    <li>Enable BESC Coin as a payment option for BESC LLC services</li>
                    <li>Expand employee base and service capabilities</li>
                    <li>Release V2 of CEX</li>
                    <li>Market to list new coins on CEX</li>
                    <li>Partner with other CEX platforms to expand reach</li>
                    <li>First BESC expansion</li>
                  </ul>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={12} className="roadmap-card">
            <Card className="blog-card-view">
              <Card.Body>
                <Card.Title className="purple" style={{ fontSize: "2em" }}>
                  Phase 3: Expansion (12 to 24 Months)
                </Card.Title>
                <Card.Text style={{ textAlign: "left", color: "white" }}>
                  <ul>
                    <li>Drive adoption across real estate and adjacent industries</li>
                    <li>Invest in additional equipment to scale operations</li>
                    <li>Expand BESC Coin ecosystem to include subcontractors and suppliers globally</li>
                    <li>More Updates Soon</li>
                  </ul>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Roadmap; 